<template>
  <div class="container-three">
    <h2>三方登录开关</h2>
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      @finish="formFinish"
    >
      <a-form-item label="版本号" name="version" required>
        <a-input v-model:value="formState.version" />
      </a-form-item>
      <a-form-item label="开关" name="enable">
        <!-- 0 - 关，1 - 开 -->
        <a-switch
          :checkedValue="1"
          :unCheckedValue="0"
          v-model:checked="formState.enable"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 6, span: 10 }">
        <a-button type="primary" html-type="submit">保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue'
import {
  querythirdParty,
  updatethirdParty
} from '@/server/modules/threeparty.js'
import { message } from 'ant-design-vue'

export default {
  setup() {
    const state = reactive({
      formState: {},
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 10
      },
      rules: {},
      formFinish() {
        updatethirdParty(state.formState)
          .then(res => {
            if (res.success) {
              message.success('保存成功')
              state.init()
            } else {
              message.error(res.retInfo)
            }
          })
          .catch(err => {
            console.log('err', err)
          })
          .finish(() => {
            console.log('formFinish')
          })
      },
      init() {
        querythirdParty().then(res => {
          console.log('res', res)
          if (res.success) {
            state.formState = res.data
          }
        })
      }
    })
    onMounted(state.init)

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.container-three {
  padding: 40px;
  background-color: #fff;
}
</style>
